import {FC} from 'react';

import styles from './index.module.css';
import concatStyles from 'helpers/concatStyles';

interface Props {
  height: number;
  width?: number;
  className?: string;
}

export const Skeleton: FC<Props> = ({height, width, className}) => {
  return (
    <div
      className={concatStyles([styles.container, className])}
      style={{height: height, minWidth: width}}
    />
  );
};

export default Skeleton;
